import RouteErrorBoundary from 'components/RouteErrorBoundary';
import { createHostGuardLoader } from 'modules/host/hostRouteLoader';
import LocaleLayout from 'modules/locale/LocaleLayout';
import { localeLoader } from 'modules/locale/localeLoader';
import React from 'react';
import { Toaster } from 'react-hot-toast';
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';

const hostGuardLoader = createHostGuardLoader();

const hostGuardedPaths = [
  'host-agenda/*',
  'host/experiences/*',
  'host/home',
  'host/home/*',
  'host/status/*',
  'host/schedule-break/*',
  'host/go-offline',
  'host/feedback',
  'host/performance/*',
  'host/profile/*',
  'host/payout/*',
  'host/transfer-booking/*',
  'host/manage-status',
  'host/review/*',
  'host/onboarding/*',
  'learning-center/*',
];

const hostGuardedRoutes = hostGuardedPaths.flatMap((path) => [
  { path, loader: hostGuardLoader },
  { path: `:locale/${path}`, loader: hostGuardLoader },
]);

const router = createBrowserRouter([
  {
    path: '/index.html',
    element: <Navigate to="/" replace />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/*',
    loader: localeLoader,
    element: <LocaleLayout />,
    errorElement: <RouteErrorBoundary />,
    children: hostGuardedRoutes,
  },
]);

const RootRouter = () => {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
};

export default RootRouter;
